// client/src/components/services_tester/ServiceCard.jsx
import React from 'react';
import { Card, CardContent, Typography, Box, Button, Stack, Chip } from '@mui/material';
import { Computer, Speed } from '@mui/icons-material';
import ServiceStatus from '../common/ServiceStatus';

const ServiceCard = ({ service, diagnostics, onTest, loading }) => {
  const status = diagnostics;
  const isHealthy = status?.status === 'healthy';
  const isUnhealthy = status?.status === 'unhealthy' || status?.status === 'error';

  return (
    <Card
      variant="outlined"
      sx={{
        borderColor: isHealthy ? 'success.main' : isUnhealthy ? 'error.main' : 'divider',
        borderRadius: 1,
        transition: 'border-color 0.2s',
        '&:hover': { borderColor: isHealthy ? 'success.dark' : 'primary.main' },
      }}
    >
      <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
        <Stack spacing={0.75}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Computer
              fontSize="small"
              color={isHealthy ? 'success' : isUnhealthy ? 'error' : 'disabled'}
            />
            <Typography
              variant="subtitle2"
              component="div"
              noWrap
              sx={{ fontWeight: 600, fontSize: '0.8rem', flex: 1 }}
            >
              {service.name}
            </Typography>
            {status?.status && (
              <Chip
                label={status.status}
                size="small"
                color={
                  isHealthy
                    ? 'success'
                    : isUnhealthy
                    ? 'error'
                    : status.status === 'unknown'
                    ? 'default'
                    : 'warning'
                }
                variant="outlined"
                sx={{ height: 18, fontSize: '0.6rem', '& .MuiChip-label': { px: 0.5 } }}
              />
            )}
          </Box>

          {/* ServiceStatus (если нужен — оставляем, но компактно) */}
          <ServiceStatus status={status} compact />

          {status?.responseTime && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Speed fontSize="inherit" color="action" />
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                {status.responseTime} ms
              </Typography>
            </Box>
          )}

          <Button
            variant="outlined"
            size="small"
            fullWidth
            startIcon={<Computer fontSize="small" />}
            onClick={() => onTest(service)}
            disabled={loading}
            sx={{ fontSize: '0.7rem', py: 0.25 }}
          >
            Тестировать
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
